var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChunksSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0953 29.3008H24.4719C22.4325 29.3008 20.7793 30.7585 20.7793 32.5568V55.4473C20.7793 57.2455 22.4325 58.7033 24.4719 58.7033H42.0953C44.1346 58.7033 45.7879 57.2455 45.7879 55.4473V32.5568C45.7879 30.7585 44.1346 29.3008 42.0953 29.3008Z",
    fill: "url(#paint0_linear_2323_17111)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0953 29.3027H24.4719C22.4325 29.3027 20.7793 30.7605 20.7793 32.5587V55.4492C20.7793 57.2475 22.4325 58.7052 24.4719 58.7052H42.0953C44.1346 58.7052 45.7879 57.2475 45.7879 55.4492V32.5587C45.7879 30.7605 44.1346 29.3027 42.0953 29.3027Z",
    fill: "url(#paint1_linear_2323_17111)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2323_17111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5308 24.0527H36.9758C34.9364 24.0527 33.2832 25.5105 33.2832 27.3087V60.6965C33.2832 62.4947 34.9364 63.9525 36.9758 63.9525H63.5308C65.5702 63.9525 67.2234 62.4947 67.2234 60.6965V27.3087C67.2234 25.5105 65.5702 24.0527 63.5308 24.0527Z",
    fill: "url(#paint2_linear_2323_17111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9758 24.3994H63.5308C65.421 24.3994 66.8767 25.7416 66.8767 27.3087V60.6965C66.8767 62.2636 65.421 63.6058 63.5308 63.6058H36.9758C35.0856 63.6058 33.6298 62.2636 33.6298 60.6965V27.3087C33.6298 25.7416 35.0856 24.3994 36.9758 24.3994Z",
    stroke: "url(#paint3_linear_2323_17111)",
    strokeWidth: 0.693293
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2323_17111",
    x: 20.8039,
    y: 11.5735,
    width: 58.898,
    height: 64.8589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.23964
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2323_17111"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2323_17111",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2323_17111",
    x1: 16.9172,
    y1: 52.4647,
    x2: 70.2486,
    y2: 16.9935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF6700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2323_17111",
    x1: 16.9172,
    y1: 52.4667,
    x2: 70.2486,
    y2: 16.9954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF6700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2323_17111",
    x1: 35.1993,
    y1: 61.6999,
    x2: 70.1358,
    y2: 31.9817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2323_17111",
    x1: 35.679,
    y1: 27.1908,
    x2: 68.9564,
    y2: 57.4575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChunksSmall);
export default __webpack_public_path__ + "static/media/icon-chunks-small.07d46bc455a9b979b4fda6e7a9b38860.svg";
export { ForwardRef as ReactComponent };